import { render, staticRenderFns } from "./BlueButton.vue?vue&type=template&id=65f1103b&scoped=true&"
import script from "./BlueButton.vue?vue&type=script&lang=js&"
export * from "./BlueButton.vue?vue&type=script&lang=js&"
import style0 from "./BlueButton.vue?vue&type=style&index=0&id=65f1103b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f1103b",
  null
  
)

export default component.exports